// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Z-Px","image":"Header_image__3msRj","name":"Header_name__1gxaT","info":"Header_info__3Jztg","infoRow":"Header_infoRow__2o-Wo"};